import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Funnel } from "@ant-design/plots";

const FunnelPlot = () => {
  const data = [
    {
      stage: "Objective",
      number: 253,
    },
    {
      stage: "Goal",
      number: 151,
    },
    {
      stage: "Plan",
      number: 113,
    },
    {
      stage: "Action",
      number: 87,
    },
    {
      stage: "Sub",
      number: 59,
    },
  ];
  const config = {
    data: data,
    height: 300,
    xField: "stage",
    yField: "number",
    legend: false,
  };
  return <Funnel {...config} />;
};

export default FunnelPlot;
